const displayNamesCache = {};

export const countryName = (code, locale = "en") => {
  try {
    if (!displayNamesCache[locale]) {
      displayNamesCache[locale] = new Intl.DisplayNames([locale], { type: "region" });
    }
    return displayNamesCache[locale].of(code) || code;
  } catch {
    return code;
  }
};

export const countryFlag = (code) => {
  if (!code || code.length !== 2) return "";
  return String.fromCodePoint(...[...code.toUpperCase()].map((c) => 0x1F1E6 + c.charCodeAt(0) - 65));
};
